const SURVEY_COMPLETED = 'survey_completed';
const NEGATIVE_EXPERIENCE = 'negative_experience';
const ALL_FEEDBACKS = 'all_feedbacks';
const NEGATIVE_FEEDBACKS = 'negative_feedbacks';

export const SMS_ALERT_TYPES = {
  SURVEY_COMPLETED,
  NEGATIVE_EXPERIENCE,
  ALL_FEEDBACKS,
  NEGATIVE_FEEDBACKS,
};

export const SMS_ALERT_OBJECTS = [
  {
    label: 'Survey Completed Alert',
    value: SURVEY_COMPLETED,
    disabledFields: [NEGATIVE_EXPERIENCE, ALL_FEEDBACKS, NEGATIVE_FEEDBACKS],
  },
  {
    label: 'Negative Customer Experience Alert',
    value: NEGATIVE_EXPERIENCE,
    disabledFields: [NEGATIVE_FEEDBACKS],
  },
  {
    label: 'All Feedback Comments Alert',
    value: ALL_FEEDBACKS,
    disabledFields: [NEGATIVE_FEEDBACKS],
  },
  {
    label: 'Negative Feedback Comments Alert',
    value: NEGATIVE_FEEDBACKS,
    disabledFields: [],
  },
];



// WEBPACK FOOTER //
// ./src/constants/smsAlerts.js